import { Button } from "@material-ui/core";
import tossball from "../../assets/images/rewards/tossball.png";
import maskgroup from "../../assets/images/rewards/BigMaskBg.png";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAuthToken } from "../../utils/auth";
import axios from "axios";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { clearStorage, getStorageItem, setStorageItem } from "../../utils/sessionStorage";
import { toast } from "react-toastify";
import { useAdCount } from './Context';

export default function Toss() {
  const navigate = useNavigate();
  const accessToken = getAuthToken();
  const [startPlay, setPlay] = useState(null);
  const [timeRemaining, setTimeRemaining] = useState(null);
  const [timeRemainingData, setTimeRemainingData] = useState(null);
  const { adCount, setAdCount, incrementAdCount } = useAdCount();
  const [ad, setAd] = useState(false);
  const [showAd, setShowAd] = useState(false);
  const userId = getStorageItem("user_id");

  const timer = (date) => {
    const intervalId = setInterval(() => {
      if (date <= 0) {
        setTimeRemainingData(0)
        clearInterval(intervalId);
        // PlaYNowFunction()
      } else {
        date = date - 1000;
        const days = Math.floor(date / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (date % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor((date % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((date % (1000 * 60)) / 1000);
        // let maindate = days;
        let mainhours = hours;
        let mainminte = minutes;
        let mainsecound = seconds;
        const countdownStr = `${mainhours}:${mainminte}:${mainsecound}`;
        setTimeRemaining(countdownStr);
      }
    }, 1000);
  };

  const PlaYNowFunction = async () => {
    if (accessToken) {
      var PlayNow = {
        method: "GET",
        url: global.config.ROOTURL.prod + "/contest/coinToss/checkCanPlay",
        headers: {
          Authorization: "Bearer " + accessToken,
        },
      };
      axios(PlayNow)
        .then(({ data }) => {
          setPlay(data);
          setTimeRemainingData(data?.remainingTime)
          timer(data?.remainingTime);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const handleWatchAdToPlay = () => {
    setShowAd(true);
    incrementAdCount();
  };

  useEffect(() => {
    setTimeout(() => {
      PlaYNowFunction();
    }, timeRemainingData === 0);
  }, [timeRemainingData === 0,]);

  useEffect(() => {
    PlaYNowFunction();
    return () => {
      setPlay(null);
    };
  }, []);

  useEffect(() => {
    if (timeRemaining === "00:00:00") {
      clearStorage("ad_count");
      setAdCount(0);
    }
  }, [timeRemaining]);

  const fetchRandomAd = async () => {
    try {
      const response = await axios.get(`${global.config.ROOTURL.prod}/ads/fetch-random`, {
        headers: {
          Authorization: "Bearer " + accessToken,
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
        },
      });
      if (response?.status === 200) {
        setAd(response?.data);
      }
    }
    catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    fetchRandomAd();
  }, []);

  const handleWatchFullAd = async () => {
    try {
      // Call the reset-time API here to reset the time and redirect the user back to /coin
      const response = await axios.get(`${global.config.ROOTURL.prod}/contest/coinToss/reset-time/${userId}`, {
        headers: {
          Authorization: "Bearer " + accessToken,
        },
      });

      const viewIncreaseResponse = await axios.post(
        `${global.config.ROOTURL.prod}/ads/increaseViewCount`,
        {
          _id: ad?._id,
          userId: userId
        },
        {
          headers: {
            Authorization: "Bearer " + accessToken,
          }
        }
      );

      if (response.status === 200 && viewIncreaseResponse.status === 200) {
        setShowAd(false);
        navigate("/coin");
      }
      else {
        setShowAd(false);
        toast.error('Some error occured!');
      }
    } catch (error) {
      console.error("Error watching ad:", error);
      setShowAd(false);
      setTimeout(() => {
        navigate("/rewards");
      }, [1000]);
    }
  };


  return (
    <div className="coinTossContainer">
      {/* Modal--advertisment */}
      <div>
        {showAd && (
          <div className="modal-backdrop-ad">
            <div className="modal-content-ad">
              <div className="modal-header-ad">
                <h2>{ad?.title}</h2>
                <button className="close-ad" onClick={() => {
                  setShowAd(false);
                }}>
                  <AiOutlineCloseCircle />
                </button>
              </div>
              <div className="modal-body-ad">
                <video
                  src={ad?.url}
                  autoPlay
                  // controls
                  onEnded={() => {
                    // setAdWatched(true);
                    handleWatchFullAd();
                  }}
                ></video>
                <p>{ad?.description}</p>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="TossContainer">
        <div className="coinTossImageContainer">
          <img alt="cointossImage" src={maskgroup} className="cointossImage" />
        </div>
        <div className="cointosscontent">
          <div>
            <p className="TossFontStyle">Toss Ka Boss</p>
            <div className="footerInnerdiv">
              <img alt="tossball" src={tossball} />
              <p className="tosssmallfont" style={{ paddingLeft: "10px" }}>
                win 2X more
              </p>
            </div>
          </div>

          {startPlay?.canPlay ? (
            <Button
              className="TossFontStyle TossButton"
              onClick={() => {
                navigate("/coin");
              }}
            >
              Play Now
            </Button>
          ) : (adCount >= 2) ? (
            <div>
              <Button
                className=" PrdictionButtondisable"
                disabled={true}
                style={{ fontSize: "17px" }}
              >
                {timeRemaining}
              </Button>
            </div>
          ) : (
            <div>
              <Button
                className="adButton"
                style={{
                  width: "130px", height: "50px",
                  fontWeight: 400, fontSize: "15px",
                  fontFamily: "Inter", lineHeight: "20px"
                }}
                onClick={handleWatchAdToPlay}
              >
                Watch Ad To Play
              </Button>
            </div>
          )}
        </div>
      </div>
    </div >
  );
}
